.wrapper {
  position: fixed;
  bottom: 40px;
  left: 0;
  right: 0;
  padding: 0 8px;
  z-index: 1;
}

.container {
  background: rgba(255, 255, 255, 0.12);
  box-shadow: -4px 0 6px 0px rgba(0, 0, 0, 0.02) inset;
  backdrop-filter: blur(64px);
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-style: solid;
  border-color: rgba(222, 222, 222, 0.12);
  padding: 4px 6px;
  border-radius: 20px;
  display: flex;
}

.tabItem {
  flex: 1;
  display: flex;
  padding: 6px;
  gap: 4px;
  text-decoration: none;
  font-size: 10px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.4);
  text-align: center;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s;
  border-radius: 16px;
  &:global(.active) {
    background: linear-gradient(180deg, rgba(245, 245, 245, 0) 0%, rgba(245, 245, 245, 0.12) 100%);
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    color: rgba(255, 255, 255, 1);
  }
}
